<template>
    <page-success :title="title" :message="message" :width="width">
        <template v-slot:actions>
            <div class="d-flex justify-center mb-12 grow">
                <v-btn rounded x-large class="mr-3" color="primary" href="https://medplay.it">
                    <span>Continua</span>
                </v-btn>
            </div>
        </template>
    </page-success>
</template>

<script>
import PageSuccess from "@/components/PageSuccess";

export default {
    name: "RecoverPasswordSuccess",
    components: {PageSuccess},
    props: ['title', 'message', 'width']
}
</script>

